module.exports = __webpack_public_path__ + "static/media/PG_Logo_dark.ede310c8.svg";